import type { UserVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveUserList = createApiThunk<UserVM[], void>(
  "users/retrieveUserList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.retrieveUserList();
  },
);
